import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError, first } from 'rxjs/operators';
import { AppSettings } from '../app-settings';
import { Observable, of } from 'rxjs';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class CategoriasService {

  constructor(private http: HttpClient, private common: CommonService) { }

  getAllCategories() {
    const url = `${AppSettings.API_URI_V2}/event-categories`;
    return this.common.getData(url);
  }

  getCategoriesByCity(cityId: number): Observable<any> {
    const url = `${AppSettings.API_URI_V2}/event-categories?id_city=${cityId}`;
    return this.common.getData(url);
  }

  getCategoriesHome() {
    const url = `${AppSettings.API_URI_V2}/event-categories?show_home=true`;
    return this.common.getDataHydra(url);
  }

  getCategoriesWithEvents() {
    const url = `${AppSettings.API_URI_V2}/event-categories?has_events=true`;
    return this.common.getData(url);
  }

  getCategoriabyId(id: number) {
    const url = `${AppSettings.API_URI_V2}/event-categories/${id}`;
    return this.common.getData(url);
  }

  getCategoriaBySlug(slug: string) {
    const url = `${AppSettings.API_URI_V2}/event-categories?slug=${slug}`;
    return this.common.getData(url);
  }

  postCategoria(categoria: any) {
    const url = `${AppSettings.API_URI_V2}/event-categories`;
    return this.common.postData(url, categoria);
  }

  putCategoria(categoriaId: number, categoria: any) {
    const formHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const url = `${AppSettings.API_URI_V2}/event-categories/${categoriaId}`;
    return this.http.put<any>(url, categoria, formHeaders).pipe(
      map(data => {
        return data;
      }), catchError((err) => {
        return of(false);
      })
    );
  }

  deleteCategoria(categoriaId: number) {
    const url = `${AppSettings.API_URI_V2}/event-categories/${categoriaId}`;
    return this.http.delete<any>(url).pipe(
      map(data => {
        return data;
      }), catchError(err => {
        return of(false);
      })
    );
  }

}
